(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  var form = document.getElementById('bzn-cart-form');
  if (!form) return;

  function updateCart(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function () { window.location.reload(); })
    .catch(function () { window.location.reload(); });
  }

  document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(this.dataset.line, 10);
      var action = this.dataset.action;
      var input = form.querySelector('[data-qty-input][data-line="' + line + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = action === 'plus' ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      updateCart(line, next);
    });
  });

  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = parseInt(this.dataset.line, 10);
      var qty = Math.max(0, parseInt(this.value, 10) || 0);
      updateCart(line, qty);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  var sel = document.querySelector('[data-sort-select]');
  if (!sel) return;
  sel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-selector"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bzn-selector').forEach(function (section) {
    var tabs   = section.querySelectorAll('[data-tab-index]');
    var panels = section.querySelectorAll('[data-panel-index]');

    function activate(idx) {
      tabs.forEach(function (t) {
        var active = t.dataset.tabIndex === String(idx);
        t.classList.toggle('bzn-is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('bzn-hidden', p.dataset.panelIndex !== String(idx));
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(this.dataset.tabIndex);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(this.dataset.tabIndex);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var burger  = document.querySelector('[data-burger]');
  var nav     = document.getElementById('bzn-nav');
  var overlay = document.querySelector('[data-nav-overlay]');
  if (!burger || !nav) return;

  function open() {
    nav.classList.add('bzn-is-open');
    if (overlay) { overlay.classList.add('bzn-is-visible'); overlay.removeAttribute('aria-hidden'); }
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    nav.classList.remove('bzn-is-open');
    if (overlay) { overlay.classList.remove('bzn-is-visible'); overlay.setAttribute('aria-hidden', 'true'); }
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    burger.getAttribute('aria-expanded') === 'true' ? close() : open();
  });
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  /* Qty +/- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var input = form.querySelector('[data-qty-input]');
    if (!input) return;
    var minus = form.querySelector('[data-qty-minus]');
    var plus  = form.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      var m = parseInt(input.max, 10) || 99;
      if (v < m) input.value = v + 1;
    });
  });

  /* Variant changed → mettre à jour CTA + prix + sticky */
  document.addEventListener('bzn:variant-changed', function (e) {
    var d = e.detail;
    if (!d) return;

    var ctaBtn    = document.querySelector('[data-add-to-cart]');
    var ctaText   = document.querySelector('[data-add-to-cart-text]');
    var ctaPrice  = document.querySelector('[data-cta-price]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    var available = d.available && d.variant;

    if (ctaBtn) {
      ctaBtn.disabled = !available;
      ctaBtn.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (ctaText) {
        ctaText.textContent = available
          ? (ctaBtn.dataset.textAddToCart || 'Add to cart')
          : (ctaBtn.dataset.textSoldOut || 'Sold out');
      }
      if (ctaPrice && d.price !== null) {
        ctaPrice.textContent = '· ' + (d.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    if (stickyPrice && d.price !== null) {
      stickyPrice.textContent = (d.price / 100).toFixed(2).replace('.', ',') + ' €';
    }
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.classList.toggle('bzn-sticky-atc__btn--disabled', !available);
    }
  });

  /* Sticky ATC visibility */
  var stickyBar = document.getElementById('bzn-sticky-atc');
  var mainCta   = document.querySelector('[data-add-to-cart]');
  if (stickyBar && mainCta && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      stickyBar.classList.toggle('bzn-sticky-atc--visible', !visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    obs.observe(mainCta);
  }

  /* Sticky ATC button → trigger main form submit */
  var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
  if (stickyBtn && mainCta) {
    stickyBtn.addEventListener('click', function () {
      mainCta.click();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcoming-drop"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-countdown-section]');
  if (!section) return;

  var elHours   = section.querySelector('[data-cd-hours]');
  var elMinutes = section.querySelector('[data-cd-minutes]');
  var elSeconds = section.querySelector('[data-cd-seconds]');

  var TEN_HOURS = 10 * 60 * 60 * 1000;

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var remaining = TEN_HOURS - (Date.now() % TEN_HOURS);
    var h = Math.floor(remaining / 3600000);
    var m = Math.floor((remaining % 3600000) / 60000);
    var s = Math.floor((remaining % 60000) / 1000);
    if (elHours)   elHours.textContent   = pad(h);
    if (elMinutes) elMinutes.textContent = pad(m);
    if (elSeconds) elSeconds.textContent = pad(s);
  }

  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
